import { useState, useCallback, useMemo } from 'react';
import AlertModal from '../components/AlertModal';

interface AlertOptions {
  title: string;
  message: string;
  variant?: 'success' | 'danger' | 'warning' | 'info';
  details?: string;
  icon?: React.ReactNode;
}

interface AlertState extends AlertOptions {
  show: boolean;
}

export const useAlert = () => {
  const [alertState, setAlertState] = useState<AlertState>({
    show: false,
    title: '',
    message: '',
    variant: 'info',
  });

  const showAlert = useCallback((options: AlertOptions) => {
    setAlertState({
      ...options,
      show: true,
      variant: options.variant || 'info',
    });
  }, []);

  const hideAlert = useCallback(() => {
    setAlertState(prev => ({ ...prev, show: false }));
  }, []);

  // Memoizar o componente para evitar re-renderizações desnecessárias
  const AlertComponent = useCallback(() => (
    <AlertModal
      show={alertState.show}
      onHide={hideAlert}
      title={alertState.title}
      message={alertState.message}
      variant={alertState.variant}
      details={alertState.details}
      icon={alertState.icon}
    />
  ), [alertState.show, alertState.title, alertState.message, alertState.variant, alertState.details, alertState.icon, hideAlert]);

  return {
    showAlert,
    hideAlert,
    AlertComponent,
  };
};

export default useAlert;





